import log from "./logger";

const API_URL: string | undefined = process.env.NEXT_PUBLIC_GPT_URL;

export type GptMessage = {
    role: "system" | "assistant" | "user";
    content: string;
    isEnd: boolean;
    src: "gpt" | "cms" | "user";
}

export const fetchFromGPT = async (messages: GptMessage[]): Promise<GptMessage> => {
    if (!API_URL) return apiErrorMessage;

    try {
        const body = JSON.stringify(messages);
        console.log("Message body length:", body.length);
        console.log("Message body preview:", body.slice(0, 800));

        const response = await fetch(API_URL, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body,
        });

        const raw = await response.text();
        console.log("API status:", response.status);
        console.log("API raw response:", raw.slice(0, 2000));

        if (!response.ok) {
            throw new Error(`API request failed with status ${response.status}: ${raw.slice(0, 2000)}`);
        }

        const data = JSON.parse(raw);
        const message = normalizeGptMessage(data);

        console.log("Message:", message);
        return message;
    } catch (error) {
        log.error("Error fetching data from GPT API:", error);
        return getRandomErrorMessage();
    }
};


const defaultMessage: GptMessage = {
    role: "user",
    content: "Keine valide Nachricht erhalten.",
    isEnd: false,
    src: "user",
};

const endMessage: GptMessage = {
    role: "assistant",
    content: "Oh entschuldige, ich muss hier leider weiter. Die Freunde drängeln beim Holo-Golf. Lass doch mal wieder quatschen! Nummer hast du ja jetzt. Hat mich echt gefreut dich, äh, mich wiederzusehen! Achja, den Kontakt bin ich dir noch schuldig: [Link: Sparkassen-Berater]! Grüß schön!",
    isEnd: true,
    src: "gpt",
}

const normalizeGptMessage = (message: any): GptMessage => {
    return typeof message === "object" &&
        ["system", "assistant", "user"].includes(message.role) &&
        typeof message.content === "string" &&
        typeof message.isEnd === "boolean" &&
        ["gpt", "cms", "user"].includes(message.src)
        ? message
        : { ...defaultMessage, ...message };
}

const apiErrorMessage: GptMessage = {
    content: "Ich kann Dir leider nicht helfen, denn NEXT_PUBLIC_GPT_URL wurde nicht gesetzt. 🤡",
    role: "assistant",
    isEnd: true,
    src: "gpt"
}

const getRandomErrorMessage = () => errorMessages[Math.floor(Math.random() * errorMessages.length)];

const errorMessages: GptMessage[] = [
    {
        content: "Die Verbindung in die Zukunft macht grade Probleme … benutze bitte die Buttons.",
        role: "assistant",
        isEnd: true,
        src: "gpt"
    },
    {
        content: "Zukunfts-Verbindung unterbrochen … Texteingabe blockiert …",
        role: "assistant",
        isEnd: true,
        src: "gpt"
    },
    {
        content: "Zukunfts-Link instabil. Texteingabe gesperrt …",
        role: "assistant",
        isEnd: true,
        src: "gpt"
    },
];
